import React from "react";
//import PropTypes from "prop-types";
import "../index.css";

//import Button from 'react-bootstrap/Button'
//import Modal from 'react-bootstrap/Modal'

//import ButtonFilled from '../components/ButtonFilled'
//import ButtonOutlined from '../components/ButtonOutlined'

import Back from '../Images/x-circle-grey.png';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
//import Col from 'react-bootstrap/Col'


//How does our price range sound? Sound good / book appoiment
// True for step 3 of individul and business tax prep and Other Services (International/ Multinational Income)
class Modal2Business extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			modalIndividual: true
		}
	}

	handleShow = () => {
		this.setState({
			modalIndividual: true
		});
	}

	handleHide = () => {
		this.setState({
			modalIndividual: false
		});
	}


	render() {
		return (
			<div>
				<Container>
					<div className="box-shadow">

						<div className="modal2-div">

							<button className="button-no-style" onClick={() => this.props.handleStep("Tax Preparation Business Compact")}>
								<img src={Back} alt="back" />
							</button>
							<p className="steps-heading dark-blue">How does our price range sound?</p>

							<Row>


								<div className="modal1">
									<p className="normal-text-center-large">If something is really not clear or confusing, please set up an appointment on Calendly.</p>
									<a className="button-filled" href="https://calendly.com/agroaccounting-east">
										Schedule a Call
                    </a>

								</div>

								<div className="modal1">
									<p className="normal-text-center-large">Sounds good?  Upload your documents and let's proceed!</p>
									<button className="button-filled" onClick={() => this.props.handleStep("Upload Documents Business")}>
										Upload Documents
                    </button>

								</div>


							</Row>
						</div>

					</div>
				</Container>
			</div>

		);
	}
}

export default Modal2Business;
